// Simple in-memory cache to dramatically speed up navigation
export const appCache = {
  reviews: null,
  tools: null,
  reviewDetails: {},
  
  clear() {
    this.reviews = null;
    this.tools = null;
    this.reviewDetails = {};
  },
  
  clearTools() {
    this.tools = null;
  },
  
  clearReviews() {
    this.reviews = null;
    this.reviewDetails = {};
  }
};